module.exports = __webpack_public_path__ + "img/console20.63af579d.jpg";